import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useRef, useCallback } from 'react';

const context = createContext(undefined);
const MultiSelectProvider = (_a) => {
    var { children } = _a, value = __rest(_a, ["children"]);
    const [hasShadow, setHasShadow] = useState(true);
    const menuListRef = useRef(null);
    const handleShadow = useCallback(() => {
        if (menuListRef.current) {
            setHasShadow(menuListRef.current.clientHeight >= 200);
        }
    }, []);
    const newValue = Object.assign(Object.assign({}, value), { handleShadow, hasShadow, menuListRef });
    return jsx(context.Provider, Object.assign({ value: newValue }, { children: children }));
};
const useMultiSelect = () => {
    const multiSelect = useContext(context);
    if (!multiSelect) {
        throw Error('`useMultiSelect` has to be used only within MultiSelectProvider');
    }
    return multiSelect;
};
/**
 * This hook can be used within the menu footer to trigger actions on the menu.
 */
const useMultiSelectActions = () => {
    const multiSelect = useContext(context);
    if (!multiSelect) {
        throw Error('`useMultiSelectActions` has to be used within a multi-select dropdown');
    }
    return { closeMenu: multiSelect.closeMenu };
};

export { MultiSelectProvider as default, useMultiSelect, useMultiSelectActions };
//# sourceMappingURL=MultiSelectProvider.js.map
